import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth, RequirePermission, RequireRole } from "@/auth/RequireAuth";
import { AppLayout } from "@/components/layout/AppLayout";
import { LoginPage } from "@/pages/login/LoginPage";
import { DashboardPage } from "@/pages/dashboard/DashboardPage";
import { StudentsListPage } from "@/pages/students/StudentsListPage";
import { StudentDetailPage } from "@/pages/students/StudentDetailPage";
import { GroupsListPage } from "@/pages/groups/GroupsListPage";
import { GroupDetailPage } from "@/pages/groups/GroupDetailPage";
import { SchedulePage } from "@/pages/schedule/SchedulePage";
import { JournalPage } from "@/pages/journal/JournalPage";
import { TeachersListPage } from "@/pages/teachers/TeachersListPage";
import { TeacherDetailPage } from "@/pages/teachers/TeacherDetailPage";
import { LeadsPage } from "@/pages/leads/LeadsPage";
import { FinancePage } from "@/pages/finance/FinancePage";
import { NotificationsPage } from "@/pages/notifications/NotificationsPage";
import { SettingsPage } from "@/pages/settings/SettingsPage";
import { MyCabinetPage } from "@/pages/my/MyCabinetPage";
import { RegistrationPage } from "@/pages/registration/RegistrationPage";
import { AttendanceMatrixPage } from "@/pages/attendance/AttendanceMatrixPage";
import { CashboxPage } from "@/pages/cashbox/CashboxPage";
import { AuditPage } from "@/pages/audit/AuditPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<DashboardPage />} />

          <Route
            path="registration"
            element={
              <RequirePermission anyOf={["leads.edit"]}>
                <RegistrationPage />
              </RequirePermission>
            }
          />

          <Route
            path="attendance"
            element={
              <RequirePermission anyOf={["attendance.mark"]}>
                <AttendanceMatrixPage />
              </RequirePermission>
            }
          />

          <Route
            path="cashbox"
            element={
              <RequirePermission anyOf={["fin.payments"]}>
                <CashboxPage />
              </RequirePermission>
            }
          />

          <Route
            path="audit"
            element={
              <RequirePermission anyOf={["set.audit"]}>
                <AuditPage />
              </RequirePermission>
            }
          />

          <Route
            path="students"
            element={
              <RequirePermission anyOf={["students.view"]}>
                <StudentsListPage />
              </RequirePermission>
            }
          />
          <Route
            path="students/:id"
            element={
              <RequirePermission anyOf={["students.view"]}>
                <StudentDetailPage />
              </RequirePermission>
            }
          />

          <Route
            path="groups"
            element={
              <RequirePermission anyOf={["groups.view"]}>
                <GroupsListPage />
              </RequirePermission>
            }
          />
          <Route
            path="groups/:id"
            element={
              <RequirePermission anyOf={["groups.view"]}>
                <GroupDetailPage />
              </RequirePermission>
            }
          />

          <Route
            path="schedule"
            element={
              <RequirePermission anyOf={["groups.view"]}>
                <SchedulePage />
              </RequirePermission>
            }
          />

          <Route
            path="journal"
            element={
              <RequirePermission anyOf={["attendance.mark", "attendance.all"]}>
                <JournalPage />
              </RequirePermission>
            }
          />

          <Route
            path="teachers"
            element={
              <RequirePermission anyOf={["teachers.view"]}>
                <TeachersListPage />
              </RequirePermission>
            }
          />
          <Route
            path="teachers/:id"
            element={
              <RequirePermission anyOf={["teachers.view"]}>
                <TeacherDetailPage />
              </RequirePermission>
            }
          />

          <Route
            path="leads"
            element={
              <RequirePermission anyOf={["leads.view"]}>
                <LeadsPage />
              </RequirePermission>
            }
          />

          <Route
            path="finance"
            element={
              <RequireRole roles={["DIRECTOR", "ACCOUNTANT"]}>
                <RequirePermission anyOf={["fin.payments", "fin.debts", "fin.expense", "fin.salary", "fin.report"]}>
                  <FinancePage />
                </RequirePermission>
              </RequireRole>
            }
          />

          <Route
            path="notifications"
            element={
              <RequirePermission anyOf={["notify.view"]}>
                <NotificationsPage />
              </RequirePermission>
            }
          />

          <Route
            path="settings"
            element={
              <RequirePermission anyOf={["set.catalog", "set.users", "set.roles", "set.integr"]}>
                <SettingsPage />
              </RequirePermission>
            }
          />

          <Route path="my" element={<MyCabinetPage />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
